import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input, Select, Checkbox } from 'semantic-ui-react'

import moment from 'moment'
import constants from '../../constants'

const options = [
  { key: 'm', text: 'Male', value: 'Male' },
  { key: 'f', text: 'Female', value: 'Female' },
  { key: 'o', text: 'Other', value: 'Other' },
]

const optionsGradeLevel = constants.breakdownGradeLevel

class StudentsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      middleName: '',
      lastName: '',
      extensionName: '',
      birthDate: '',
      gender: '',
      address: '',
      nickName: '',
      lrn: '',
      studentNumber: '',
      religion: '',
      placeOfBirth: '',
      mobile1: '',
      mobile2: '',
      contactPerson: '',
      contactPersonNumber: '',
      contactPersonAddress: '',
      guardianName: '',
      guardianNumber: '',
      guardianAddress: '',
      guardianOccupation: '',
      guardianOfficeAddress: '',
      beenHospitalized: false,
      hospitalReason: '',
      medicalHistory: '',
      showModal: false,
      studentId: '',
      gradeLevel: ''
    };
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  toggle = () => this.setState(prevState => ({ beenHospitalized: !prevState.beenHospitalized }))

  handleSubmit = () => {
    const data = {
      firstName: this.state.firstName,
      middleName: this.state.middleName,
      lastName: this.state.lastName,
      extensionName: this.state.extensionName,
      birthDate: this.state.birthDate,
      gender: this.state.gender,
      address: this.state.address,
      nickName: this.state.nickName,
      lrn: this.state.lrn,
      studentNumber: this.state.studentNumber,
      religion: this.state.religion,
      placeOfBirth: this.state.placeOfBirth,
      mobile1: this.state.mobile1,
      mobile2: this.state.mobile2,
      contactPerson: this.state.contactPerson,
      contactPersonNumber: this.state.contactPersonNumber,
      contactPersonAddress: this.state.contactPersonAddress,
      guardianName: this.state.guardianName,
      guardianNumber: this.state.guardianNumber,
      guardianAddress: this.state.guardianAddress,
      guardianOccupation: this.state.guardianOccupation,
      guardianOfficeAddress: this.state.guardianOfficeAddress,
      beenHospitalized: this.state.beenHospitalized,
      hospitalReason: this.state.hospitalReason,
      medicalHistory: this.state.medicalHistory,
      gradeLevel: this.state.gradeLevel
    };
    this.props.handleUpdate(data,this.state.studentId);
    this.setState({
      firstName: '',
      middleName: '',
      lastName: '',
      extensionName: '',
      birthDate: '',
      gender: '',
      address: '',
      nickName: '',
      lrn: '',
      studentNumber: '',
      religion: '',
      placeOfBirth: '',
      mobile1: '',
      mobile2: '',
      contactPerson: '',
      contactPersonNumber: '',
      contactPersonAddress: '',
      guardianName: '',
      guardianNumber: '',
      guardianAddress: '',
      guardianOccupation: '',
      guardianOfficeAddress: '',
      beenHospitalized: false,
      hospitalReason: '',
      medicalHistory: '',
      studentId: '',
      gradeLevel: ''
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  componentDidMount() {
    this.setState({
      firstName: this.props.student.firstName,
      middleName: this.props.student.middleName,
      lastName: this.props.student.lastName,
      extensionName: this.props.student.extensionName,
      birthDate: moment(this.props.student.birthDate).format('YYYY-MM-DD'),
      gender: this.props.student.gender,
      address: this.props.student.address,
      nickName: this.props.student.nickName,
      lrn: this.props.student.lrn,
      studentNumber: this.props.student.studentNumber,
      religion: this.props.student.religion,
      placeOfBirth: this.props.student.placeOfBirth,
      mobile1: this.props.student.mobile1,
      mobile2: this.props.student.mobile2,
      contactPerson: this.props.student.contactPerson,
      contactPersonNumber: this.props.student.contactPersonNumber,
      contactPersonAddress: this.props.student.contactPersonAddress,
      guardianName: this.props.student.guardianName,
      guardianNumber: this.props.student.guardianNumber,
      guardianAddress: this.props.student.guardianAddress,
      guardianOccupation: this.props.student.guardianOccupation,
      guardianOfficeAddress: this.props.student.guardianOfficeAddress,
      beenHospitalized: this.props.student.beenHospitalized,
      hospitalReason: this.props.student.hospitalReason,
      medicalHistory: this.props.student.medicalHistory,
      studentId: this.props.student.studentId,
      gradeLevel: this.props.student.gradeLevel
    })
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      firstName: newProps.student.firstName,
      middleName: newProps.student.middleName,
      lastName: newProps.student.lastName,
      extensionName: newProps.student.extensionName,
      birthDate: moment(newProps.student.birthDate).format('YYYY-MM-DD'),
      gender: newProps.student.gender,
      address: newProps.student.address,
      nickName: newProps.student.nickName,
      lrn: newProps.student.lrn,
      studentNumber: newProps.student.studentNumber,
      religion: newProps.student.religion,
      placeOfBirth: newProps.student.placeOfBirth,
      mobile1: newProps.student.mobile1,
      mobile2: newProps.student.mobile2,
      contactPerson: newProps.student.contactPerson,
      contactPersonNumber: newProps.student.contactPersonNumber,
      contactPersonAddress: newProps.student.contactPersonAddress,
      guardianName: newProps.student.guardianName,
      guardianNumber: newProps.student.guardianNumber,
      guardianAddress: newProps.student.guardianAddress,
      guardianOccupation: newProps.student.guardianOccupation,
      guardianOfficeAddress: newProps.student.guardianOfficeAddress,
      beenHospitalized: newProps.student.beenHospitalized,
      hospitalReason: newProps.student.hospitalReason,
      medicalHistory: newProps.student.medicalHistory,
      studentId: newProps.student.studentId,
      gradeLevel: newProps.student.gradeLevel
    })
  }

  render() {

    return (
      <Modal
        trigger={
          <Button icon size='tiny' onClick={this.openModal}>
            <Icon name='pencil' />
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Edit a Student</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.firstName} name='firstName' label='First name' placeholder='First name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.middleName} name='middleName' label='Middle name' placeholder='Middle name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.lastName} name='lastName' label='Last name' placeholder='Last name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.extensionName} name='extensionName' label='Extension name' placeholder='Extension name' onChange={this.handleChange}/>
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.nickName} name='nickName' label='Nickname' placeholder='Nickname' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.lrn} name='lrn' label='LRN' placeholder='LRN' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.studentNumber} name='studentNumber' label='Student #' placeholder='00-0000' onChange={this.handleChange}/>
              <Form.Field value={this.state.gradeLevel} name='gradeLevel' control={Select} label='Grade Level' options={optionsGradeLevel} placeholder='Grade Level' onChange={this.handleChange}/>
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field>
                <label>Birthdate</label>
                <Input value={this.state.birthDate} name='birthDate' type='date' placeholder='Birthdate' onChange={this.handleChange}/>
              </Form.Field>
              <Form.Field value={this.state.gender} name='gender' control={Select} label='Gender' options={options} placeholder='Gender' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.religion} name='religion' label='Religion' placeholder='Religion' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.placeOfBirth} name='placeOfBirth' label='Place Of Birth' placeholder='Place Of Birth' onChange={this.handleChange}/>
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.mobile1} name='mobile1' label='Mobile Number 1' placeholder='Mobile Number 1' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.mobile2} name='mobile2' label='Mobile Number 2' placeholder='Mobile Number 2' onChange={this.handleChange}/>
            </Form.Group>
            <Form.Field value={this.state.address} name='address' control={Input} label='Address' placeholder='Address' onChange={this.handleChange}/>
            <h4> Contact Person in case of Emergency</h4>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.contactPerson} name='contactPerson' label='Name' placeholder='Name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.contactPersonNumber} name='contactPersonNumber' label='Contact Number' placeholder='Contact Number' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.contactPersonAddress} name='contactPersonAddress' label='Address' placeholder='Address' onChange={this.handleChange}/>
            </Form.Group>

            <h4> Guardian</h4>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.guardianName} name='guardianName' label='Name' placeholder='Name' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.guardianNumber} name='guardianNumber' label='Contact Number' placeholder='Contact Number' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.guardianAddress} name='guardianAddress' label='Address' placeholder='Address' onChange={this.handleChange}/>
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.guardianOccupation} name='guardianOccupation' label='Occupation' placeholder='Occupation' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.guardianOfficeAddress} name='guardianOfficeAddress' label='Office Address' placeholder='Office Address' onChange={this.handleChange}/>
            </Form.Group>
            <h4> Medical History </h4>
            <Form.Group widths='equal'>
              <Form.Field control={Checkbox} checked={this.state.beenHospitalized} name='beenHospitalized' label='Have Been Hospitalized' onChange={this.toggle}/>
              <Form.Field control={Input} value={this.state.hospitalReason} name='hospitalReason' label='Reason' placeholder='Reason' onChange={this.handleChange}/>
              <Form.Field control={Input} value={this.state.medicalHistory} name='medicalHistory' label='Medical History' placeholder='Medical History' onChange={this.handleChange}/>

            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default StudentsEdit;
